import { render, staticRenderFns } from "./FixtureNotificationComponent.vue?vue&type=template&id=82699284&"
import script from "./FixtureNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./FixtureNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports